import React from 'react';
import { CRQ_STATUSES, CRQ_STATUS_DISPLAY_NAMES } from 'AppSrc/core/crq/crq-statuses';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';


// default statuses to show for opened crqs
const defaultStatuses = [
  CRQ_STATUSES.submitted,
  CRQ_STATUSES.coordinator,
  CRQ_STATUSES.peerReview,
  CRQ_STATUSES.approvals,
  CRQ_STATUSES.scheduled,
  CRQ_STATUSES.implementation,
  CRQ_STATUSES.completed,
];

// in search context also show closed and cancelled
const searchStatuses = [
  ...defaultStatuses,
  CRQ_STATUSES.closed,
  CRQ_STATUSES.cancelled,
];

const CrqListStatusFilter = ({
  selectedStatuses,
  toggleStatus,
  listIsSearch,
}) => {
  const filterStatuses = listIsSearch ? searchStatuses : defaultStatuses;
  return (
    <div className="crq-list-checkbox-filter crq-list-status-filter">
      <h3>Stage</h3>
      <ul>
        {filterStatuses.map((status) => {
          const isSelected = selectedStatuses.includes(status);
          // const statusName = CRQ_STATUS_DISPLAY_NAMES[status];
          let statusName = CRQ_STATUS_DISPLAY_NAMES[status];
          if (statusName === 'Peer Review') {
            statusName = 'Peer/L3 Review';
          }
          return (
            <li key={status}>
              <OptionButton
                className={`checkbox-option ${isSelected ? 'checkbox-option-selected' : ''}`}
                onClick={toggleStatus}
                option={status}
              >
                <div className="svg-container">
                  {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
                </div>
                {statusName}
              </OptionButton>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

CrqListStatusFilter.propTypes = {
  selectedStatuses: PropTypes.arrayOf(PropTypes.string),
  toggleStatus: PropTypes.func,
  listIsSearch: PropTypes.bool,
};

export { CrqListStatusFilter };
